<template>
    <div class="management">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
                <b-card
                    class="module-card apprentice-simple-card-with-banner"
                    no-body
                    @click="redirectPWS">
                    <b-card-img
                        class="module-card-banner banner"
                        :src="routes.baseUrl() + '/images/pws/pws-banner.jpg'"
                        top></b-card-img>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('tools.profile_paper') }}</b-card-title>
                        <div class="muted-text">
                            {{
                                $t(
                                    'tools.find_all_kinds_of_information_and_good_sources_here_to_help_you_create_your_profile_paper',
                                )
                            }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <b-card
                    class="module-card apprentice-simple-card-with-banner"
                    no-body
                    @click="redirectPixabay">
                    <b-card-img
                        class="module-card-banner banner"
                        :src="routes.baseUrl() + '/images/pixabay-banner.jpg'"
                        top></b-card-img>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">Pixabay</b-card-title>
                        <div class="muted-text">
                            {{ $t('tools.find_and_download_royalty_images_for_your_paper') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div
                class="col-12 col-md-6 col-lg-4"
                v-if="hasBritannica">
                <b-card
                    class="skills-card apprentice-simple-card-with-banner"
                    no-body
                    @click="redirectBritannica">
                    <b-card-img
                        class="skills-card-banner banner"
                        :src="routes.baseUrl() + '/images/britannica/banner.jpg'"
                        top></b-card-img>
                    <b-card-body body-class="skills-card-body body">
                        <b-card-title title-tag="h5">Britannica</b-card-title>
                        <div class="muted-text">
                            {{ $t('tools.quality_and_up_to_date_resources_and_images') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div
                class="col-12 col-md-6 col-lg-4"
                v-if="!$authUser.isStudent()">
                <b-card
                    class="module-card apprentice-simple-card-with-banner"
                    no-body
                    @click="redirectPresentations">
                    <b-card-img
                        class="module-card-banner banner"
                        :src="routes.baseUrl() + '/images/lesson/lesson.jpg'"
                        top></b-card-img>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('presentations') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('tools.manage_you_lesson_presentations_online_and_use_them_live_in_the_class_room') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <b-card
                    class="module-card apprentice-simple-card-with-banner"
                    no-body
                    @click="redirectExams">
                    <b-card-img
                        class="module-card-banner banner"
                        :src="routes.baseUrl() + '/images/exams/examentraining2.jpg'"
                        top></b-card-img>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('tools.practice_exams_and_pta') }}</b-card-title>
                        <div class="muted-text">
                            {{ $t('tools.find_exams_from_previous_years_here_to_help_you_prepare_for_the_exam') }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div
                class="col-12 col-md-6 col-lg-4"
                v-if="!$authUser.isStudent()">
                <b-card
                    class="module-card apprentice-simple-card-with-banner"
                    no-body
                    @click="redirectDatabank">
                    <b-card-img
                        class="module-card-banner banner"
                        :src="routes.baseUrl() + '/images/databank/databank.jpg'"
                        top></b-card-img>
                    <b-card-body body-class="module-card-body body">
                        <b-card-title title-tag="h5">{{ $t('tools.assignments_database') }}</b-card-title>
                        <div class="muted-text">
                            {{
                                $t(
                                    'tools.view_various_assignments_for_your_subject_here_shared_by_teachers_cultural_institutions_and_organizations',
                                )
                            }}
                        </div>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-tools-index-component',
    props: {
        hasBritannica: Boolean,
        hasDigistudies: Boolean,
        schoolId: Number,
    },
    methods: {
        redirectBritannica() {
            window.location.href = this.routes.britannica(this.schoolId);
        },

        redirectPresentations() {
            window.location.href = this.routes.presentation();
        },

        redirectExams() {
            window.location.href = this.routes.practiceExams();
        },

        redirectDatabank() {
            window.location.href = this.routes.databank();
        },

        redirectPWS() {
            window.location.href = this.routes.pws();
        },

        redirectPixabay() {
            window.location.href = this.routes.pixabay();
        },
    },
};
</script>

<style scoped lang="scss">
.management {
    .row {
        > div {
            margin-bottom: $grid-gutter-width;
        }
    }
}
</style>
